var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"74a692cf74317df2b35fce6b1456087f0fa9663b"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

const {
  publicRuntimeConfig: { SENTRY_ENABLED },
} = getConfig();

Sentry.init({
  dsn: SENTRY_DSN,
  enabled: SENTRY_ENABLED,
  environment:
    process.env.VERCEL_ENV || process.env.NODE_ENV || process.env.ENVIRONMENT || 'not-set',
  release: process.env.RELEASE,
  sampleRate: 1.0,
  // 1% of all transactions
  tracesSampleRate: 0.01,
  ignoreErrors: [
    'Qualified: invalid visitor state',
    'Non-Error promise rejection captured with value: invalid_request',
    'Non-Error promise rejection captured with value: unauthorized',
    'Non-Error promise rejection captured with value: Handshake Timeout Reached',
    'Non-Error promise rejection captured with value: delay_connect',
    'ResizeObserver loop completed with undelivered notifications.',
    'This Suspense boundary received an update before it finished hydrating',
    `undefined is not an object (evaluating 'r["@context"].toLowerCase')`,
    'Handshake Timeout Reached',
    'Attempting to change configurable attribute of unconfigurable property', // only happens on specific browsers and does not affect user
    `Can't find variable: _AutofillCallbackHandler`, // non user impacting error which occurs in instagram browser
    'TypeError: cancelled', // sentry sdk error
    'TypeError: NetworkError when attempting to fetch resource.', // sentry sdk error
    `Failed to execute 'fetch' on 'Window': Request cannot be constructed from a URL`, // error that comes from calling vercel speed insights
    'mutiny-client', // dont' send mutiny client errors
    'Network Error', // network errors
    'Failed to call api method',
    'SecurityError',
    'CustomError: Jsloader error',
    'Retries exceeded',
    'document is not defined',
    'Qualified: invalid domain',
    'Access is denied for this document', // happens when user disables cookies
    'Request aborted', // axios error when user closes browser during request
    'fetch failed', // apollo network error
    'getCookie is not defined', // unknown cookie error which has been happening a lot and surpassing error quotas
  ],
});
